export default __webpack_public_path__ + "static/media/gallery_35.02318955.jpg";